import { useFormContext } from "react-hook-form";
import { VatTypeEnum } from "../../../../enums/VatTypeEnum";
import { AmountHelper } from "../../../../helpers/AmountHelper";
import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFPlainText } from "../../../Shared/NewForms/NFPlainText";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFLookupInput } from "../../../Shared/NewForms/NFLookupInput";
import { EnumHelper } from "../../../../helpers/EnumHelper";
import { NFLookupUnit } from "../../../Shared/NewForms/NFLookupUnit";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import React from "react";
import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { NFLookupCurrency } from "../../../Shared/NewForms/NFlookupCurrency";

export const SettlementVendorOpeningBalancesDetailSettlement = () => {
    const tableName = "settlements";
    const { t } = useTranslation();

    return (
        <>
            <NFormTable fieldArray={tableName}>
                <NFLookupInput
                    title={t("ArApObjectType")}
                    fieldName="arApObjectType"
                    items={EnumHelper.GetArApObjectTypeEnum()}
                />
                <NFLookupCurrency
                    title={t("Currency")}
                    fieldName="currencyId"
                />
                <NFIntInput title={t("Advance")} fieldName="advance" />
            </NFormTable>
        </>
    );
};
